if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
    }

    hide(preventFocus = false) {
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cartNotification) cartNotification.setActiveElement(this.openedBy);
      this.modalContent.innerHTML = '';

      if (preventFocus) this.openedBy = null;
      super.hide();

      window.setTimeout(() => {
        this.resumeAutoplayOnPage();
      }, 50);

      document.body.style.overflow = "scroll";
      document.body.style.padding = "0";
    }

    show(opener) {
      opener.setAttribute('aria-disabled', true);
      opener.classList.add('loading');
      opener.querySelector('.loading-overlay-spinner').classList.remove('hidden');

      fetch(opener.getAttribute('data-product-url'))
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
          this.preventDuplicatedIDs();
          this.removeDOMElements();
          this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

          removeElementsByScreenSize(this.modalContent);

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          if (window.ProductModel) window.ProductModel.loadShopifyXR();

          this.removeGalleryListSemantic();
          this.updateImageSizes();
          this.preventVariantURLSwitching();
          super.show(opener);
          this.autoplayActiveMediaInModal();
          this.initModalGallery();
          
          // Add smooth animation here
          this.modalContent.style.opacity = '0';
          this.modalContent.style.transform = 'scale(0.8)';
          this.modalContent.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
          
          setTimeout(() => {
            this.modalContent.style.opacity = '1';
            this.modalContent.style.transform = 'scale(1)';
          }, 0);
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          opener.querySelector('.loading-overlay-spinner').classList.add('hidden');
        });

        document.body.style.overflow = "hidden";
        document.body.style.padding = "0 4px 0 0";
    }

    setInnerHTML(element, html) {
      element.innerHTML = html;

      // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value)
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }

    preventVariantURLSwitching() {
      const variantPicker = this.modalContent.querySelector('variant-radios,variant-selects');
      if (!variantPicker) return;

      variantPicker.setAttribute('data-update-url', 'false');
    }

    removeDOMElements() {
      const pickupAvailability = this.productElement.querySelector('pickup-availability');
      if (pickupAvailability) pickupAvailability.remove();

      const productModal = this.productElement.querySelector('product-modal');
      if (productModal) productModal.remove();

      const modalDialog = this.productElement.querySelectorAll('modal-dialog');
      if (modalDialog) modalDialog.forEach(modal => modal.remove());
    }

    preventDuplicatedIDs() {
      const sectionId = this.productElement.dataset.section;
      this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${ sectionId }`);
      this.productElement.querySelectorAll('variant-selects, variant-radios, product-info').forEach((element) => {
        element.dataset.originalSection = sectionId;
      });
    }

    removeGalleryListSemantic() {
      const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
      if (!galleryList) return;

      galleryList.setAttribute('role', 'presentation');
      galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
    }

    updateImageSizes() {
      const product = this.modalContent.querySelector('.product');
      const desktopColumns = product.classList.contains('product--columns');
      if (!desktopColumns) return;

      const mediaImages = product.querySelectorAll('.product__media img');
      if (!mediaImages.length) return;

      let mediaImageSizes = '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';
      
      if (product.classList.contains('product--medium')) {
        mediaImageSizes = mediaImageSizes.replace('715px', '605px');
      } else if (product.classList.contains('product--small')) {
        mediaImageSizes = mediaImageSizes.replace('715px', '495px');
      }

      mediaImages.forEach(img => img.setAttribute('sizes', mediaImageSizes));
    }

    autoplayActiveMediaInModal() {
      const activeSlide =
        this.modalContent.querySelector('.product-media-item.is-active') ||
        this.modalContent.querySelector('[data-media-id].is-active') ||
        this.modalContent.querySelector('[data-media-id]');

      if (!activeSlide) return;

      const deferredMedia = activeSlide.querySelector('deferred-media[data-autoplay="true"]');
      if (!deferredMedia) return;

      deferredMedia.loadContent(false);
      if (typeof deferredMedia.autoplayVideo === 'function') {
        deferredMedia.autoplayVideo();
      } else {
        const video = deferredMedia.querySelector('video');
        if (video) {
          video.muted = true;
          video.playsInline = true;
          const p = video.play();
          if (p && p.catch) p.catch(() => {});
        }
      }
    }

    initModalGallery() {
      const galleries = this.modalContent.querySelectorAll('media-gallery');
      galleries.forEach(function (gallery) {
        // Reset init flag so carousel re-inits fresh for each modal open
        gallery._aaSwipeReady = false;
        gallery._aaEls = null;
        gallery._aaIndex = 0;

        var viewer = gallery.querySelector('[id^="GalleryViewer"]');
        var track = viewer ? viewer.querySelector('.product__media-list') : null;
        var slides = track ? Array.from(track.querySelectorAll('.slider-slide[data-media-id]')) : [];
        if (!viewer || !track || slides.length < 2) return;

        gallery._aaSwipeReady = true;
        gallery._aaEls = { viewer: viewer, track: track, slides: slides,
          prev: viewer.querySelector('.slider-button--prev'),
          next: viewer.querySelector('.slider-button--next') };
        gallery._aaIndex = 0;
        track.style.transform = 'translateX(0)';

        function setIdx(idx) {
          var max = slides.length - 1;
          idx = Math.max(0, Math.min(max, idx));
          gallery._aaIndex = idx;
          // track is always 100% of viewer width in modal (margin reset via CSS)
          var w = viewer.clientWidth;
          track.style.transform = 'translateX(' + (-idx * w) + 'px)';
          slides.forEach(function (s, i) {
            if (i === idx) { s.classList.add('is-active'); s.setAttribute('aria-current', 'true'); }
            else { s.classList.remove('is-active'); s.removeAttribute('aria-current'); }
          });
        }

        function go(delta) {
          var next = (gallery._aaIndex || 0) + delta;
          if (next < 0) next = slides.length - 1;
          if (next >= slides.length) next = 0;
          setIdx(next);
        }

        var prev = gallery._aaEls.prev;
        var next = gallery._aaEls.next;
        if (prev) { prev.style.display = ''; prev.addEventListener('click', function () { go(-1); }); }
        if (next) { next.style.display = ''; next.addEventListener('click', function () { go(1); }); }

        // Touch swipe
        var startX = 0;
        viewer.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
        viewer.addEventListener('touchend', function (e) {
          var dx = e.changedTouches[0].clientX - startX;
          if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1);
        }, { passive: true });

        // Thumbnail clicks
        gallery.addEventListener('click', function (e) {
          var btn = e.target && e.target.closest ? e.target.closest('button[aria-controls^="GalleryViewer"]') : null;
          if (!btn) return;
          var li = btn.closest('li[data-target]');
          if (!li) return;
          var target = li.getAttribute('data-target');
          var idx = slides.findIndex(function (s) { return s.getAttribute('data-media-id') === target; });
          if (idx >= 0) setIdx(idx);
        });

        window.addEventListener('resize', function () { setIdx(gallery._aaIndex || 0); }, { passive: true });

        setIdx(0);
      });
    }

    resumeAutoplayOnPage() {
      const galleries = document.querySelectorAll('media-gallery');

      galleries.forEach((gallery) => {
        if (gallery.closest('quick-add-modal, .quick-add-modal, #QuickAddModal')) return;

        const activeSlide =
          gallery.querySelector('.product-media-item.is-active') ||
          gallery.querySelector('[data-media-id].is-active') ||
          gallery.querySelector('[data-media-id]');

        if (!activeSlide) return;

        const deferredMedia = activeSlide.querySelector('deferred-media[data-autoplay="true"]');
        if (!deferredMedia) return;

        deferredMedia.loadContent(false);

        if (typeof deferredMedia.autoplayVideo === 'function') {
          deferredMedia.autoplayVideo();
        } else {
          const video = deferredMedia.querySelector('video');
          if (video) {
            video.muted = true;
            video.playsInline = true;
            const p = video.play();
            if (p && p.catch) p.catch(() => {});
          }
        }
      });
    }

  });
}